import { Location } from './location.model';

export class RegionalLocations {
    region: string;
    locations: Array<Array<Location>>;
}
